// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createStoreSalesManager = (client) => ({
    /**
     * `GET /store/sales-manager`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreGetSalesManager
     * @source packages/modules/b2c-core/src/api/store/sales-manager/route.ts
     */
    list: (query, headers) => client.fetch("/store/sales-manager", { method: "GET", query, headers }),
});
//# sourceMappingURL=sales-manager.js.map